import mitt, { Emitter } from 'mitt';
import { GameMainTypesEnum } from '../../constants';

export type NotificationProps = {
  type: string;
  transformMessage?: boolean; // 是否将标题转换多语言
  transformDescription?: boolean; // 是否将内容转换多语言
  isLogout?: boolean; // 退出登录
  [propName: string]: any;
};

export enum EventEnum {
  LOGIN = 'login',
  LOTTERY_GAME = 'lotteryGame',
  REFRESH_PAGE = 'refreshPage',
  REFRESH_HOME_GAMES = 'refreshHomeGames',
  HOME_PAGE_TOP_HEIGHT = 'homePageTopHeight',
  HOME_SEARCH_GAME = 'homeSearchGame',
  TRY_SEARCH_GAME = 'trySearchGame',
  HOME_SEARCH_GAME_RESET = 'homeSearchGameReset',
  CUSTOM_HEADER_BAR_RIGHT_CLICK = 'customHeaderBarRightClick',
  HOME_PAGE_SCROLL = 'homePageScroll',
  YU_E_BAO = 'yuebao',
  PAGE_API_RELOAD = 'pageApiReload',
  RED_PACKETS_RAIN = 'redPacketsRain',
}

export type LoginData = {
  type: 0 | 1 | 2; // 0:关闭 1:登录 2:注册
  redirect?: string; // 重定向路由
};

export type RefreshHomeGames = {
  mainType: GameMainTypesEnum;
  reset: boolean;
  action?: string;
};

type Events = {
  [EventEnum.LOGIN]: LoginData;
  [EventEnum.REFRESH_PAGE]?: boolean; // 刷新页面
  [EventEnum.LOTTERY_GAME]?: boolean; // 显示半屏投注
  [EventEnum.REFRESH_HOME_GAMES]?: RefreshHomeGames; // 刷新首页数据
  [EventEnum.HOME_PAGE_TOP_HEIGHT]?: number; // 首页swiper,notice高度
  [EventEnum.HOME_SEARCH_GAME]?: string; // 首页游戏搜索
  [EventEnum.TRY_SEARCH_GAME]?: string; // 试玩游戏搜索
  [EventEnum.HOME_SEARCH_GAME_RESET]?: any; // 首页游戏搜索重置
  [EventEnum.CUSTOM_HEADER_BAR_RIGHT_CLICK]?: any; // 自定义header右侧点击事件
  [EventEnum.HOME_PAGE_SCROLL]?: GameMainTypesEnum; // 首页滚动到菜单位置
  [EventEnum.YU_E_BAO]?: any; // 利息宝
  [EventEnum.PAGE_API_RELOAD]?: any; // 重新加载页面接口请求
  [EventEnum.RED_PACKETS_RAIN]?: any; // 红包雨
};

const emitter: Emitter<Events> = mitt<Events>();

export default emitter;
